// extracted by mini-css-extract-plugin
module.exports = {"recaptchaTerms":"RecaptchaTerms_recaptchaTerms__1ANzG","marginBottomRemoved":"RecaptchaTerms_marginBottomRemoved__2KWng"};